// This is just a temporary placeholder, to make the CI/CD pipeline work, since it tries to check
// if a deployment was successful by pinging the expected url, we should clean that up and then
// remove this page later

function App() {
  return null;
}

export default App;
